import {Loading} from "../../../../components/common";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";


import * as o2Api from "../../../../api/api";
import numeral from "numeral";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../../config/formatter";
import DefaultLayout from "../../../../layout/DefaultLayout";
import connect from "react-redux/es/components/connect";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import React, {useEffect, useMemo, useRef, useState} from "react";


const PopupKitchenPrtForm = (props) => {
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const gridStyle = useMemo(() => ({height: 450, width: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [dataCheck, setDataCheck] = useState(false);
    const [ipPortCheck, setIpPortCheck] = useState(false);
    const [posPortCheck, setPosPortCheck] = useState(true);
    const [error, setError] = useState({visible: false, message: ""});
    const { user } = useSelector((props) => props.account);
    //console.log("props::: " , props);
    const [params] = useSearchParams();

    const [company, setCompany] = useState([{cmpCd: "", cmpNm: "전체"}]);
    const [brand, setBrand] = useState([{brandCd: "", brandNm: "전체"}]);
    const [store, setStore] = useState([{storeCd: "", storeNm: "전체"}]);
    const [pos, setPos] = useState([{deviceId: ""}]);
    const [storeKitchenPrt, setStoreKitchenPrt] = useState({ //최초 값 설정
        cmpCd : params.get("cmpCd"),
        brandCd : params.get("brandCd"),
        storeCd : params.get("storeCd"),
        prtType: "2",
        deviceId: "01",
        prtNo: "1",
        prtNm: "",
        port: "COM1",
        rate: "9600",
        ip: "127.0.0.1",
        useYn: "Y",
    });

    const onChangeStoreKitchenPrt = (e) => {

        if(e.target.name === 'prtType'){
            if(e.target.value === '1'){
                storeKitchenPrt.port = "";
                setIpPortCheck(true);
                setPosPortCheck(false);
            } else if(e.target.value === '2'){
                setIpPortCheck(false);
                setPosPortCheck(true);
            }
        }

        setStoreKitchenPrt({
            ...storeKitchenPrt,
            [e.target.name]: e.target.value,
        });
        //console.log("변경 시 storeKitchenPrt::; " , storeKitchenPrt);
    };


    //여기부터 코드 재사용(StoreCornerListWhere)하도록 수정할것
    useEffect(() => {
        getCompany();
        if (params.get("storeCd") !== null){
            getStoreDevice();
        }
        if (params.get("seq") > 0) {
            setDataCheck(true);
            getStoreKitchenPrtInfo();
        }

    }, []);

    const getStoreDevice = () => {

        const searchParams = {
            cmpCd : params.get("cmpCd"),
            brandCd : params.get("brandCd"),
            storeCd : params.get("storeCd"),
            useYn: "Y"
        };
        setLoading(true);
        o2Api.getStoreDevice(searchParams).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                setPos(responseBody);
                setLoading(false);
            }
        });
    };

    const getStoreKitchenPrtInfo = () => {

        const searchParams = {
            cmpCd : params.get("cmpCd"),
            brandCd : params.get("brandCd"),
            storeCd : params.get("storeCd"),
            seq : params.get("seq")
            //useYn: "Y"
        };
        setLoading(true);
        o2Api.getStoreKitchenPrtInfo(searchParams).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                console.log("getStoreKitchenPrtInfo()-> responseBody:: ", responseBody);

                if(responseBody.prtType === "1"){
                    setIpPortCheck(true);
                    setPosPortCheck(false);
                } else if(responseBody.prtType === "2"){
                    setIpPortCheck(false);
                    setPosPortCheck(true);
                }
                setStoreKitchenPrt(responseBody);
                setLoading(false);
            }
        });
    };

    const handleSelect = (e, value) => {
        if (value === "C") {
            props.onSelect(e.target.value, "C");
            getBrand(e.target.value);
        } else if (value === "B") {
            props.onSelect(e.target.value, "B");
            getStore(params.get("cmpCd"), e.target.value);
        } else if (value === "S") {
            props.onSelect(e.target.value, "S");
            getCorner(params.get("cmpCd"), params.get("brandCd"), e.target.value)
        } else if (value === "O") {
            props.onSelect(e.target.value, "O");
        }
    };

    const getCompany = async () => {
        console.log("params.get(cmpCd)::; " , params.get("cmpCd"));

        console.log("params.get(userId)::; " , params.get("userId"));

        if (params.get("cmpCd") !== null) {
            const {data: result} = await o2Api.getCompany(params.get("cmpCd"));
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([responseBody]);
                //props.onSelect(params.get("cmpCd"), "C");
                getBrand(params.get("cmpCd"));
            }
        } else {
            const params = {
                userId: params.get("userId")
            }

            const {data: result} = await o2Api.getCompanyList(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([{cmpCd: "", cmpNm: "전체"}]);
                setCompany((state) => state.concat(responseBody));
            }
        }
    };

    const getBrand = async (cmpCd) => {
        if (params.get("brandCd") !== null) {
            const {data: result} = await o2Api.getBrand(params.get("cmpCd"), params.get("brandCd"));
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                //props.onSelect(params.get("brandCd"), "B");
                setBrand([responseBody]);

                getStore(params.get("cmpCd"), params.get("brandCd"));
            }
        } else {
            const {data: result} = await o2Api.getBrandList(cmpCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setBrand([{brandCd: "", brandNm: "전체"}]);
                setBrand((state) => state.concat(responseBody));
            }
        }
    };

    const getStore = async (cmpCd, brandCd) => {
        const storeCd = params.get("storeCd");

        if (params.get("storeCd") !== null) {
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                storeCd: storeCd,
                manageDiv: "0"
                //,userId: params.get("userId")
            };

            console.log("params::; ", params);

            const {data: result} = await o2Api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    setStore(responseBody);
                }
            }
        } else {
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                manageDiv: "0"
                //,userId: params.get("userId")
            };

            const {data: result} = await o2Api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    setStore([{storeCd: "", storeNm: "전체"}]);
                    setStore((state) => state.concat(responseBody));
                }
            }
        }
    }; //End 점포 조회


    //저장
    const save = async () => {
        setError({visible: false, message: ""});

        if(storeKitchenPrt.prtType ==='1'){
            storeKitchenPrt.deviceId = "";
            pos[0].deviceId = "";
        }

        if (confirm("저장하시겠습니까?")) {
            const StoreKitchenPrt = {
                ...storeKitchenPrt,
                prtType: storeKitchenPrt.prtType,
                deviceId: storeKitchenPrt.deviceId ? storeKitchenPrt.deviceId : pos[0].deviceId,
                prtNo: storeKitchenPrt.prtNo,
                prtNm: storeKitchenPrt.prtNm,
                port: storeKitchenPrt.port,
                rate: storeKitchenPrt.rate,
                ip: storeKitchenPrt.ip,
                useYn: storeKitchenPrt.useYn,
                instUser: params.get("userId"),
                updUser: params.get("userId")
            }
            setLoading(true);

            console.log("저장 전 StoreKitchenPrt :: " , StoreKitchenPrt);

            try {
                const {data: result} = await o2Api.putStorePrt(StoreKitchenPrt);
                const {responseBody, responseCode, responseMessage} = result;
                console.log("result::; " , result);

                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    window.close();

                } else {
                    setError({visible: true, message: responseMessage});
                }
            } catch (e) {
                setError({visible: true, message: e.message});
            } finally {
                setLoading(false);
            }
        }
    }; //save 종료



    /*###################화면 Grid 영역###########################*/
    return (
        <>
         <div style={containerStyle}>
             {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
             {loading ? <Loading/> : null}

             <div style={{height: 20}}/>
             <CRow>
                 <CCol xs={4}>
                     <CInputGroup size="sm">
                         <CInputGroupText style={{width: 70}}>운영사</CInputGroupText>
                         <CFormSelect id="company"
                                      value={params.get("cmpCd")}
                                      onChange={(e) => handleSelect(e, "C")} >
                             {company.map((item, index) => {
                                 return (
                                     <option key={index} value={item.cmpCd}>{item.cmpNm}</option>
                                 );
                             })}
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>
                 <CCol xs={4}>
                     <CInputGroup size="sm">
                         <CInputGroupText style={{width: 70}}>휴게소</CInputGroupText>
                         <CFormSelect id="brand"
                                      value={params.get("brandCd")}
                                      onChange={(e) => handleSelect(e, "B")}>
                             {brand.map((item, index) => {
                                 return (
                                     <option key={index} value={item.brandCd}>{item.brandNm}</option>
                                 );
                             })}
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>

                 <CCol xs={4}>
                     <CInputGroup size="sm">
                         <CInputGroupText style={{width: 70}}>매장</CInputGroupText>
                         <CFormSelect id="store"
                                      value={params.get("storeCd")}
                                      onChange={(e) => handleSelect(e, "S")}>
                             {store.map((item, index) => {
                                 return (
                                     <option key={index} value={item.storeCd}>{item.storeNm}</option>
                                 );
                             })}
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>
             </CRow>

             <div style={{height: 10}}/>

             <CRow>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>프린터유형</CInputGroupText>
                         <CFormSelect id="prtType" name="prtType"
                                      onChange={onChangeStoreKitchenPrt} value={storeKitchenPrt.prtType}>
                             <option value={"2"}>POS</option>
                             <option value={"1"}>IP</option>
                         </CFormSelect>
                     </CInputGroup>

                 </CCol>
                 {posPortCheck &&
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{width: 150}}>연결 POS번호</CInputGroupText>
                         <CFormSelect id="deviceId" name="deviceId"
                                      value={storeKitchenPrt.deviceId}
                                      onChange={onChangeStoreKitchenPrt}
                         >

                             {pos.map((item, index) => {
                                 return (
                                     <option key={index} value={item.deviceId}>{item.deviceId}번</option>
                                 );
                             })}
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>
                 }
             </CRow>
             <div style={{height: 10}}/>
             <CRow>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>프린터번호</CInputGroupText>
                         <CFormSelect id="prtNo" name="prtNo" disabled={dataCheck} onChange={onChangeStoreKitchenPrt} value={storeKitchenPrt.prtNo}>
                             <option value={"1"}>1번</option>
                             <option value={"2"}>2번</option>
                             <option value={"3"}>3번</option>
                             <option value={"4"}>4번</option>
                             <option value={"5"}>5번</option>
                             <option value={"6"}>6번</option>
                             <option value={"7"}>7번</option>
                             <option value={"8"}>8번</option>
                             <option value={"9"}>9번</option>
                             <option value={"10"}>10번</option>
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>프린터명</CInputGroupText>
                         <CFormInput id="prtNm" name="prtNm" onChange={onChangeStoreKitchenPrt} value={storeKitchenPrt.prtNm} />
                     </CInputGroup>
                 </CCol>
             </CRow>
             <div style={{height: 10}}/>
             <CRow>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         {ipPortCheck &&
                            <CInputGroupText style={{ width: 150 }}>네트웍포트</CInputGroupText>
                         }
                         {ipPortCheck &&
                            <CFormInput id="port" name="port" onChange={onChangeStoreKitchenPrt} value={storeKitchenPrt.port} />
                         }

                         {posPortCheck &&
                            <CInputGroupText style={{ width: 150 }}>시리얼포트</CInputGroupText>
                         }
                         {posPortCheck &&
                             <CFormSelect id="port" name="port" onChange={onChangeStoreKitchenPrt}
                                          value={storeKitchenPrt.port}>
                                 <option value={"COM1"}>COM1</option>
                                 <option value={"COM2"}>COM2</option>
                                 <option value={"COM3"}>COM3</option>
                                 <option value={"COM4"}>COM4</option>
                                 <option value={"COM5"}>COM5</option>
                                 <option value={"COM6"}>COM6</option>
                                 <option value={"COM7"}>COM7</option>
                                 <option value={"COM8"}>COM8</option>
                                 <option value={"COM9"}>COM9</option>
                                 <option value={"COM10"}>COM10</option>
                             </CFormSelect>
                         }
                     </CInputGroup>

                 </CCol>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>시리얼 포트 속도</CInputGroupText>
                         <CFormSelect id="rate" name="rate" onChange={onChangeStoreKitchenPrt}  value={storeKitchenPrt.rate}>
                             <option value='9600'>9600</option>
                             <option value='14440'>14440</option>
                             <option value='19200'>19200</option>
                             <option value='38400'>38400</option>
                             <option value='56000'>56000</option>
                             <option value='57600'>57600</option>
                             <option value='115200'>115200</option>
                             <option value='128000'>128000</option>
                             <option value='256000'>256000</option>
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>
             </CRow>

             <div style={{height: 10}}/>
             <CRow>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>IP</CInputGroupText>
                         <CFormInput id="ip" name="ip" onChange={onChangeStoreKitchenPrt} value={storeKitchenPrt.ip} />
                     </CInputGroup>
                 </CCol>
                 <CCol xs={6}>
                     <CInputGroup className={"mb-1"} size={"sm"}>
                         <CInputGroupText style={{ width: 150 }}>사용유무</CInputGroupText>
                         <CFormSelect id="useYn" name="useYn" onChange={onChangeStoreKitchenPrt}   value={storeKitchenPrt.useYn}>
                             <option value='Y'>사용</option>
                             <option value='N'>미사용</option>
                         </CFormSelect>
                     </CInputGroup>
                 </CCol>

             </CRow>
             <div style={{height: 15}}/>

             <div className="d-grid gap-1" style={{marginTop: 10}}>
                 <CButton onClick={save}>저장</CButton>
             </div>


         </div>
        </>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};
export default connect(null, null)(PopupKitchenPrtForm);

/*
const mapStateToProps = (state) => {
       const {account, store, selected} = state;
       return {
            account, store, selected
       };
   };
export default connect(mapStateToProps, null)(PopupKitchenPrtForm);
*/





